import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import FieldValidationError from 'lune-ui-lib/src/components/FieldValidationError'

import Field from 'views/CalculateEmissions/RFQ/components/Field'
import { showColumnPickerModal } from 'views/CalculateEmissions/RFQ/modals/ColumnPickerModal'

import { ParameterName } from '../utils/sharedLogic'

type ColumnPickerProps = {
    parameterName: ParameterName
    headers: string[]
    headerStartIndex: number
    exampleRow: string[]
    label: string
    columnIndex: number | undefined
    onUpdate: (columnIndex: number | undefined) => void
    error?: string
    columnAutoFilled?: boolean
    fetchColumnValues: (index: number) => string[]
    // Leaving this as unknown, as we only need the key from the mappings here (for Mini chips)
    mappings?: [string, unknown][]
}

// TODO handle required/optional data differently? For now everything is seen as optional here
const ColumnPicker = ({
    label,
    headers,
    headerStartIndex,
    columnIndex,
    onUpdate,
    exampleRow,
    error,
    columnAutoFilled,
    parameterName,
    fetchColumnValues,
    mappings,
}: ColumnPickerProps) => {
    return (
        <>
            <Field
                error={error}
                onClick={async () => {
                    const selection = await showColumnPickerModal({
                        propertyName: label,
                        headers,
                        headerStartIndex,
                        exampleRow,
                        columnIndex,
                        parameterName,
                        fetchColumnValues,
                    })
                    if (selection !== undefined) {
                        onUpdate(selection)
                    }
                }}
                placeholder={`Add column for ${label}`}
                label={columnIndex !== undefined ? headers[columnIndex] : undefined}
                subLabel={mappings?.map(([key]) => key)}
                rightButtonIcon={columnIndex !== undefined ? <CloseIcon /> : undefined}
                onRightButtonClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    onUpdate(undefined)
                }}
                leftButtonIcon={columnIndex === undefined ? <AddIcon /> : undefined}
                onLeftButtonClick={(e) => {
                    e.preventDefault()
                }}
                sx={{
                    ...(columnAutoFilled && {
                        backgroundColor: 'Blue50',
                        '&:hover': {
                            backgroundColor: 'Blue100',
                        },
                    }),
                }}
            />
            {error && <FieldValidationError error={error} />}
        </>
    )
}

export default ColumnPicker
